import { render } from "./ChangeUser.vue?vue&type=template&id=72cf52f7&scoped=true"
import script from "./ChangeUser.vue?vue&type=script&lang=ts"
export * from "./ChangeUser.vue?vue&type=script&lang=ts"

import "./ChangeUser.vue?vue&type=style&index=0&id=72cf52f7&lang=css"
import "./ChangeUser.vue?vue&type=style&index=1&id=72cf52f7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-72cf52f7"

export default script